module.exports = __webpack_public_path__ + "static/media/Melissa4_preview.c7c6535b.jpg";